// extracted by mini-css-extract-plugin
var _1 = "dInYtnuJnkM5FQfY5Kc1";
var _2 = "hy7dj66tQqJfygHUov5z";
export { _1 as "fullPageLoader", _2 as "loadingComponent" }
